import { render, staticRenderFns } from "./pondDetails.vue?vue&type=template&id=5c089752&scoped=true"
import script from "./pondDetails.vue?vue&type=script&lang=js"
export * from "./pondDetails.vue?vue&type=script&lang=js"
import style0 from "./pondDetails.vue?vue&type=style&index=0&id=5c089752&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c089752",
  null
  
)

export default component.exports